<template>
  <div class="geoP contentBack">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>地理标志</el-breadcrumb-item>
      <el-breadcrumb-item class="breadSelected"
        >地标产品管理
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="geoLeft">
      <p>地理标志产品管理</p>
      <div v-if="leftScroll == 1" class="topBlank"></div>
      <div
        class="geoProBox"
        v-for="(item, index) of geoProlist"
        :key="index"
        @click="imgSelected(index)"
        :class="{ lll: imgclick == index }"
      >
        <div>
          <img
            :class="{
              notClick: imgclick !== index,
              imgClick: imgclick == index,
            }"
            :src="require(`../assets/imgs/products/${item.productNew}.png`)"/>
        </div>
        <!-- <div><img :src="../assets/imgs/products/洪雅雅连.jpg"></div> -->
        <p
          class="h1"
          :style="{ color: imgclick == index ? '#0064D0' : '#000' }"
        >
          {{ item.product }}
        </p>
        <p class="h2">{{ item.da }}</p>
        <p class="h3">{{ item.pd }}</p>
      </div>
    </div>
    <div class="geoRight">
      <div class="alertType">
        <div :class="{ chooseAlert: alert == 0 }" @click="alertClick(0)">
          用标企业
        </div>
        <div :class="{ chooseAlert: alert == 1 }" @click="alertClick(1)">
          引用标准
        </div>
      </div>
      <!-- 用标企业 -->
      <div v-if="alert == 0" class="alertResult alertResult1">
        <div class="listTitle">企业列表</div>
        <div class="alrtbtn">
          <el-button @click="daochu">导出Excel</el-button>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
          @sort-change="sort"
        >
          <el-table-column type="selection" width="40" :resizable="false">
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="50"
            :resizable="false"
          >
          
          </el-table-column>
          <el-table-column
            label="企业名称"
            prop="ap"
            min-width="140"
            show-overflow-tooltip
            :resizable="false"
          ></el-table-column>
          <el-table-column
            label="法人代表"
            prop="frdb"
            min-width="80"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            label="注册日期"
            prop="clrq"
            sortable="custom"
            min-width="103"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            label="注册资金(万元)"
            prop="zczb"
            min-width="120"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            label="注册地址"
            prop="apad"
            min-width="100"
            :resizable="false"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="所属区域"
            prop="cnty"
            min-width="77"
            :resizable="false"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="检验状态"
            prop="inspectionStatus"
            :resizable="false"
            min-width="77"
          ></el-table-column>
          <el-table-column
            label="检验结果"
            prop="inspectionResult"
            min-width="77"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            label="检验日期"
            prop="inspectionDate"
            min-width="95"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            label="最近检验记录日期"
            prop="inspectionRecordDate"
            min-width="140"
            :resizable="false"
          ></el-table-column>
          <el-table-column label="操作" min-width="180" :resizable="false">
            <template slot-scope="scope">
              <div class="changeAlert">
                <button
                  style="margin-right: 10px; width: 62px"
                  @click="checkNote(scope.row)"
                >
                  检验记录
                </button>
                <button @click="checkHis(scope.row)" style="width: 62px">
                  检验历史
                </button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 引用标准 -->
      <div
        v-if="alert == 1"
        class="alertResult alertResult1"
        style="overflow-y: unset"
      >
        <!-- <a href="http://view.officeapps.live.com/op/view.aspx?src=https://testfiles.obs.cn-east-3.myhuaweicloud.com/reponse.xls" class="download" download='报告' target="_blank" style="color:#000"><i></i>22222</a> -->
        <div class="listTitle">引用标准</div>
        
        <div class="geosbdetail geosbdetail1">
          <div v-html="proStand"></div>
          <!-- <p
            style="margin: 100px auto; font-size: 22px; color: #666"
            v-if="urls.length == 0"
          >
            暂无数据
          </p> -->
          <!-- <div v-else>
            <img
              v-for="(item, index) of urls"
              :key="index"
              v-lazy="item"
              style="width: 100%"
            />
          </div> -->
        </div>
      </div>
    </div>
    <!-- ---------popBOX---------- -->
    <!-- 检验记录 -->
    <div v-if="checkBox" class="popBoxMask"></div>
    <div v-if="checkBox" class="popBox" style="min-width: 723px">
      <div class="boxHeader">
        检验记录
        <i class="el-icon-close" @click="closeTkCheck"> </i>
      </div>
      <div class="boxContent">
        <div class="listTitle titleBold">录入信息</div>
        <div class="boxForm">
          <div class="checkform">
            <div style="width: 51%">
             <span style="color:red;">*</span>  <span>检验记录日期：</span
              ><el-date-picker
                v-model="notedate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                disabled
              >
              </el-date-picker>
            </div>
            <div style="width: 49%">
             <span style="color:red;">*</span>  <span>检验记录员：</span
              ><el-input placeholder="录入记录员" v-model="checkman"></el-input>
            </div>
          </div>
          <div class="checkform" style="margin-top: 18px">
            <div style="width: 49%; margin-left: 27px">
             <span style="color:red;">*</span>  <span>检验日期：</span
              ><el-date-picker
                v-model="checkdate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
            <div style="width: 45%">
            <span style="color:red;">*</span>   <span style="margin-right: 10px">检验结果：</span>
              <el-radio v-model="radio" label="1">合格</el-radio>
              <el-radio v-model="radio" label="0">不合格</el-radio>
            </div>
          </div>
          <!-- 上传 -->
          <div
            class="checkform"
            style="margin-top: 18px; justify-content: unset"
          >
          <span style="color:red;">*</span>   <span >检验文件：</span>
            <div class="upload_demo">
              <div>
                <i class="el-icon-upload2" style="margin-right: 5px"></i>
                <span>上传文件</span>
              </div>
              <span>暂支持：Word、PDF、Excel</span>
              <input
                type="file"
                ref="clearFile"
                @change="getFile($event)"
                multiple="multiplt"
                class="add-file-right-input"
                accept=".docx,.doc,.pdf,.xlsx,.xls"
              />
            </div>
          </div>
          <!-- 上传文件列表 -->
          <div v-if="fileList.length > 0" class="filelist">
            <div v-for="(ele, eleindex) of fileList" :key="eleindex">
              <i class="el-icon-paperclip" style="margin-right: 6px"></i>
              <span>{{ ele }}</span>
              <i class="el-icon-close" @click="deleteupload(eleindex)"></i>
            </div>
          </div>
        </div>
        <div class="reBtnb">
          <el-button @click="quxiao">取消</el-button>
          <el-button @click="submitAddFile">确认</el-button>
        </div>
      </div>
    </div>
    <!-- 检验历史 -->
    <div v-if="checkHistory" class="popBoxMask"></div>
    <div v-if="checkHistory" class="popBox" style="min-width: 723px">
      <div class="boxHeader">
        检验历史
        <i class="el-icon-close" @click="closeTkCheck2"> </i>
      </div>
      <div class="boxContent chekcB">
        <div class="checkT"><span>检验记录时间</span><span>检验详情</span></div>
        <div class="checkC" v-for="(item, index) of history" :key="index">
          <div>{{ item.inspectionRecordDate }}</div>
          <div class="bluecircle"></div>
          <div>
            检验时间：{{ item.inspectionDate }}；检验结果：{{
              item.inspectionResult == "1" ? "合格" : "不合格"
            }}；检验记录员：{{ item.inspectionRecorder }}； 检验报告：<span>
              <i class="el-icon-paperclip"></i>
              <span
                v-for="(doc, docindex) of item.inspectionDoc.split(';')"
                :key="docindex"
                @click="openDoc(doc)"
                >{{ doc }};</span
              >
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- ------------------------- -->
  </div>
</template>
<script>
// import PDFJS from 'pdfjs-dist'
export default {
  data() {
    return {
      geoProlist: [],
      // geoProlistNew:[],
      imgclick: 0,
      alert: 0,
      tableData: [],
      multipleSelection: [],
      productt: "",
      checkBox: false,
      radio: "1",
      addArr: [],
      checkdate: "",
      notedate: "",
      checkman: "",
      ap: "",
      fileList: [],
      checkHistory: false,
      history: [],
      leftScroll: 0,
      orderType: "",
      // urls: [],
      proStand:'',
    };
  },

  methods: {
    openDoc(doc) {
      
      if (
        doc.split(".").indexOf("pdf") == -1 &&
        doc.split(".").indexOf("PDF") == -1
      ) {
         window.open('http://zscqapi.mianyang.cn/fx/product/download?filePath='+encodeURI("/opt/myfxfiles/") +doc+'&isOnLine=false&token='+localStorage.getItem('token'))

      } else {
    
        window.open('http://zscqapi.mianyang.cn/fx/product/download?filePath='+encodeURI("/opt/myfxfiles/") +doc+'&isOnLine=true&token='+localStorage.getItem('token'))
      }
    },
    // ///////////////////////////////////////////
    // test(e,url){
    //   window.open('http://view.officeapps.live.com/op/view.aspx?src=https://testfiles.obs.cn-east-3.myhuaweicloud.com/reponse.xls')
    
    ////////////////////////////////////////////////
    closeTkCheck() {
      this.checkBox = false;
    },
    closeTkCheck2() {
      this.checkHistory = false;
    },
    // 获取地理标志产品
    getGeoProducts() {
      return new Promise((resolve, error) => {
        this.$get("/product/landmarkPro", {
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          this.geoProlist = res.data;
          this.productt = this.geoProlist[0].product;

          // console.log('this.geoProlist',this.geoProlist)
          // this.geoProlistNew = this.geoProlist
          // console.log('this.geoProlistNew',this.geoProlistNew)
          
          this.geoProlist.forEach((ele) => {
            if(ele.product == '峨眉山茶'){
              ele.productNew = 'img1'
            }
             if(ele.product == '五通桥豆腐乳'){
              ele.productNew = 'img2'
            }
             if(ele.product == '金口河乌天麻'){
              ele.productNew = 'img3'
            }
             if(ele.product == '犍为茉莉花茶'){
              ele.productNew = 'img4'
            }
             if(ele.product == '夹江书画纸'){
              ele.productNew = 'img5'
            }
             if(ele.product == '金口河川牛膝'){
              ele.productNew = 'img6'
            }
             if(ele.product == '夹江叠鞘石斛'){
              ele.productNew = 'img7'
            }
             if(ele.product == '峨边竹笋'){
              ele.productNew = 'img8'
            }
          })
          // console.log('this.geoProlistNew',this.geoProlistNew)
          // this.geoProlist.forEach((ele) => {
          //   ele.pd =
          //     ele.pd.split("-")[0] +
          //     "年" +
          //     ele.pd.split("-")[1] +
          //     "月" +
          //     ele.pd.split("-")[2] +
          //     "日";
          // }
          // );
          // resolve();
        });
      });
    },
    imgSelected(index) {
      // debugger;
      this.imgclick = index;
      this.productt = this.geoProlist[index].product;
      this.getmarkProduct();
      this.getMoveinStandard();
    },
    alertClick(val) {
      this.alert = val;
      this.getMoveinStandard()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取地理标志产品用标企业
    getmarkProduct() {
      this.$get("/product/landmarkProUserAp", {
        token: localStorage.getItem("token"),
        product: this.productt,
        type: 0,
        orderType: this.orderType,
      }).then((res) => {
        this.tableData = res.data;
        this.tableData.forEach((ele) => {
          if (ele.inspectionStatus == "0") {
            ele.inspectionStatus = "未检验";
          } else if (ele.inspectionStatus == "1") {
            ele.inspectionStatus = "已检验";
          }
          if (ele.inspectionResult == "1") {
            ele.inspectionResult = "合格";
          } else if (ele.inspectionResult == "0") {
            ele.inspectionResult = "不合格";
          }
        });
      });
    },
    // 导出
    daochu() {
      if (this.multipleSelection.length > 0) {
        // console.log('---',this.multipleSelection.length)
        let aps = [];
        this.multipleSelection.forEach((ele) => {
          aps.push(ele.ap);
        });
        aps = aps.join(";");
        // console.log('aps',aps)
        let aLink = document.createElement("a");
        aLink.href =
          this.$url +
          "product/proExport?token=" +
          localStorage.getItem("token") +
          "&aps=" +
          aps +
          "&type=" +
          "0" +
          "&orderType=" +
          this.orderType;
        aLink.click();
      } else {
        let aLink1 = document.createElement("a");
        aLink1.href =
          this.$url +
          "product/proExport?token=" +
          localStorage.getItem("token") +
          "&product=" +
          this.productt +
          "&type=" +
          "0" +
          "&orderType=" +
          this.orderType;
        aLink1.click();
      }
    },
    // 检验记录
    checkNote(row) {
      this.checkBox = true;
      this.ap = row.ap;
      this.radio = '1';
    },
    // 监听文件上传，对文件类型再次进行限制
    getFile(event) {
      var file = event.target.files;
      for (var k in file) {
        if (file.hasOwnProperty(k)) {
          this.fileList.push(file[k].name);
        }
      }
      // 循环文件列表
      for (let i = 0; i < file.length; i++) {
        var imgName = file[i].name;
        var idx = imgName.lastIndexOf(".");
        if (idx != -1) {
          var ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          if (
            ext != "pdf" &&
            ext != "doc" &&
            ext != "docx" &&
            ext != "xlsx" &&
            ext != "xls"
          ) {
          } else {
            this.addArr.push(file[i]);
          }
        } else {
        }
      }
    },
    // 将数据提交给后台
    submitAddFile() {
      if (this.addArr.length == 0) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      }
      var formData = new FormData();
      formData.append("inspectionResult", this.radio);
      formData.append("inspectionDate", this.checkdate);
      formData.append("inspectionRecorder", this.checkman);
      formData.append("ap", this.ap);
      formData.append("landmarkType", 2);
      formData.append("token", localStorage.getItem("token"));
      for (var i = 0; i < this.addArr.length; i++) {
        // debugger;
        formData.append("files", this.addArr[i]);
      }
      this.axios.post("/product/upload", formData).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            type: "success",
            message: "更新检验记录成功!",
          });
          this.checkBox = false;
          // this.reload()
          this.imgSelected(this.imgclick);
        }
      });
    },
    quxiao() {
      this.checkBox = false;
    },
    deleteupload(index) {
      this.fileList.splice(index, 1);
      this.addArr.splice(index, 1);
    },
    checkHis(row) {
      this.checkHistory = true;
      this.$get("/product/listIns", {
        token: localStorage.getItem("token"),
        ap: row.ap,
        type: 2,
      }).then((res) => {
        this.history = res.data;
      });
    },
    // 监听左侧滚动条
    scrollHandle() {
      let scrollObj = document.querySelector(".geoLeft"); // 获取滚动区域
      // let clientHeight = scrollObj.clientHeight; // 容器的高度
      let scrollTop = scrollObj.scrollTop; // 已滚动的距离
      if (scrollTop > 50) {
        this.leftScroll = 1;
      } else {
        this.leftScroll = 0;
      }
    },
    // 排序
    sort(colum) {
      this.orderType = colum.order;
      if (this.orderType == "descending") {
        this.orderType = "desc";
      } else if (this.orderType == "ascending") {
        this.orderType = "asc";
      }
      this.getmarkProduct();
    },
    // 获取引用标准
    getMoveinStandard() {
      this.$get("/product/landmarkProStand", {
        token: localStorage.getItem("token"),
        product: this.productt,
      }).then((res) => {
        this.proStand = res.data.body_info
        // console.log('-----',this.proStand)
        // let size = res.data.size;
        // let url = res.data.url;
        // let urls = [];
        // for (let i = 1; i <= size; i++) {
        //   var p = url + "-" + i + ".jpg";
        //   urls.push(p);
        // }
        // this.urls = urls;
      });
    },
  },
  created() {},
  watch: {
    checkBox() {
      if (this.checkBox == false) {
        (this.radio = ""),
          (this.addArr = []),
          (this.checkdate = ""),
          (this.checkman = ""),
          (this.ap = ""),
          (this.fileList = []);
      }
    },
  },
  mounted() {
    // 监听左侧滚动条
    let dom = document.getElementsByClassName("geoLeft")[0];
    if (dom) {
      dom.addEventListener("scroll", this.scrollHandle, true);
    }
    ////////////////
    this.getGeoProducts().then(() => {

      this.getmarkProduct();
      this.getMoveinStandard();
  
    });
   
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    this.notedate = year + "/" + month + "/" + day;
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandle);
  },
};
</script>
<style>
@media (max-width: 1400px) {
  .geoLeft > p {
    font-size: 15px !important;
  }
}
.geosbdetail1 {
  overflow: auto !important;
  height: 75vh !important;
  min-height: 574px;
}
.geoP {
  display: flex;
  justify-content: space-between;
  background: #f2f2f2;
}
.geoLeft {
  width: 12.5%;
  height: 100%;
  overflow-y: auto;
  background: #fff;
  position: relative;
}
.geoLeft > p {
  font-size: 16px;
  color: #000;
  margin: 17px 0 12px 20px;
}
.geoRight {
  width: 87%;
  height: 100%;
  background: #fff;
}
.geoProBox {
  width: 83%;
  margin: auto;
  border: 1px solid #dddddd;
  margin-bottom: 17px;
  cursor: pointer;
  border-radius: 3px;
}
.geoProBox .h1 {
  font-size: 14px;
  text-align: center;
}
.geoProBox .h2 {
  font-size: 12px;
  text-align: center;
  color: #474747;
}
.geoProBox .h3 {
  font-size: 12px;
  text-align: center;
  color: #818181;
  margin-bottom: 3px;
}
.geoProBox > div {
  width: 85%;
  margin: 9px auto 0;
}
.geoProBox > div > img {
  width: 100%;
}
.lll {
  border: 1px solid #0064d0;
  box-shadow: 0px 0px 10px 0px rgba(0, 100, 208, 0.26);
}
.imgClick {
  width: 100%;
}
.notClick {
  -webkit-filter: grayscale(0.8); /* Webkit */
  filter: rgb(190, 189, 189); /* IE6-9 */
  filter: grayscale(0.8); /* W3C */
}
.alertResult1 {
    width: 97%;
    margin-left: 20px;
    max-height: 81vh;
}
.checkform {
  display: flex;
  justify-content: space-between;
}
.checkform span {
  font-size: 14px;
  color: #606060;
}
.checkform .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 214px;
}
.checkform .el-input {
  width: 214px;
}
.checkform .el-input__inner {
  height: 26px;
  line-height: 26px;
}
.checkform .el-input__icon {
  line-height: 26px;
}
.upload_demo {
  position: relative;
}
.upload_demo > input {
  position: absolute;
  top: 0;
  left: 0;
  /* z-index: 1; */
  opacity: 0;
  cursor: pointer;
}
.upload_demo > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 106px;
  height: 32px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  /* z-index: 2; */
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  margin-top: -7px;
}
.upload_demo > span {
  margin-left: 120px;
  font-size: 12px;
  color: #818181;
}
.filelist {
  margin: 15px 0 0 90px;
  background: #fff;
  padding: 0 13px;
  color: #262626;
  font-size: 14px;
  width: 300px;
}
.filelist > div {
  line-height: 26px;
}
.filelist .el-icon-close {
  font-size: 12px;
  color: #818181;
  margin-top: 8px;
  margin-right: 15px;
}
.filelist > div:hover {
  background: #e7f3ff;
}
.filelist span {
  display: inline-block;
  max-width: 240px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: middle;
}
.checkT {
  margin-left: 51px;
  color: #474747;
  font-size: 16px;
  margin-bottom: 24px;
}
.checkT > span {
  margin-right: 50px;
}
.checkC {
  display: flex;
  margin-left: 38px;
  /* margin-top: 20px; */
  height: 73px;
}
.checkC > div:first-child {
  font-size: 16px;
  border-right: 2px solid rgba(0, 0, 0, 0.06);
  width: 148px;
  text-align: center;
  line-height: 58px;
}
.checkC > div:last-child {
  font-size: 14px;
  margin-left: 26px;
  width: 89%;
  padding: 7px 0;
  color: #474747;
}
.checkC:hover {
  background: #f1f8ff;
}
.checkC > div:last-child > span {
  cursor: pointer;
}
.checkC:hover.checkC > div:last-child > span {
  color: #1471d5;
}
.checkC:hover.checkC > div:last-child {
  color: #000;
}
.bluecircle {
  width: 8px;
  height: 8px;
  border: 2px solid #1890ff;
  border-radius: 50%;
  margin-top: 24px;
  margin-left: -6.5px;
  background: #fff;
}
.chekcB {
  min-height: 300px;
}
.topBlank {
  background: #fff;
  width: 12.1%;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
}
/*定义滚动条样式（高宽及背景）*/
::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度， width：对应竖滚动条的宽度  height：对应横滚动条的高度*/
  height: 6px;
  background: #e5e7e0;
}
/*定义滑块 样式*/
::-webkit-scrollbar-thumb {
  height: 100px; /* 滚动条滑块长度 */
  background-color: #ccc;
}

.el-scrollbar__wrap {
  margin-bottom: -17px !important;
}
</style>